import { render } from "./shuiqiu2.vue?vue&type=template&id=01583972&scoped=true"
import script from "./shuiqiu2.vue?vue&type=script&lang=js"
export * from "./shuiqiu2.vue?vue&type=script&lang=js"

import "./shuiqiu2.vue?vue&type=style&index=0&id=01583972&lang=scss&scoped=true"

import exportComponent from "D:\\project\\digital-signage-cockpit-40\\防疫数据驾驶舱4.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01583972"]])

export default __exports__